export class ListSqlEnginesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "sqlEngines",
            "baseName": "sqlEngines",
            "type": "Array<SqlEngine>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSqlEnginesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
